import { useState } from 'react';
import { Lock } from 'lucide-react';
import { getSettings } from '@/lib/api/settings';
import { lockStore, useLockState } from '@/lib/auth/lockStore';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui';

/** Full-screen page shown whenever the API answers 423 SYSTEM_LOCKED. Retry re-checks; sign out always works. */
export function LockedPage() {
  const { message } = useLockState();
  const { logout, isAuthenticated } = useAuth();
  const [checking, setChecking] = useState(false);

  const retry = async () => {
    setChecking(true);
    try {
      // /auth/me is exempt from the lock, so use a locked endpoint to test the real state.
      await getSettings();
      lockStore.unlock();
    } catch {
      /* still locked (interceptor refreshed the message) or offline */
    } finally {
      setChecking(false);
    }
  };

  return (
    <main
      role="alert"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-4 bg-bg p-6 text-center"
    >
      <Lock aria-hidden className="size-16 text-danger" />
      <h1 className="text-3xl font-bold text-fg">System locked</h1>
      <p className="max-w-lg text-lg text-fg-muted">
        {message || 'The system has been locked by an administrator. Please contact support.'}
      </p>
      <div className="mt-2 flex gap-2">
        <Button size="lg" onClick={retry} loading={checking}>
          Check again
        </Button>
        {isAuthenticated && (
          <Button size="lg" variant="outline" onClick={() => void logout()}>
            Sign out
          </Button>
        )}
      </div>
    </main>
  );
}
